// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  prod_stripe_key: 'pk_live_51Huh1cCSTmdgoUr3PDJAnedYOqZKDxTQi4djl9jwmoZCsKZFOdNTGZVVLC9gpBS3YVxt1oEwGvr4P4JyUQRMyFq300LN3EaaEp',
  prod_stripe_priceId: 'price_1I95o8CSTmdgoUr3Uin6nuSn',
  prod_stripe_priceId_1200: 'price_1J1FkBCSTmdgoUr31iuZ9pJG',
  prod_stripe_priceId_1500: 'price_1J7tP4CSTmdgoUr3SWvi0dTq',
  prod_stripe_priceId_3000: 'price_1J1Fk1CSTmdgoUr3jmp0I3QM',
  prod_stripe_priceId_4000: 'price_1J561FCSTmdgoUr3CBIm4yd3',
  prod_stripe_priceId_10000: 'price_1J566uCSTmdgoUr3iNEOWiww',
  test_stripe_key: 'pk_test_51Huh1cCSTmdgoUr3D1nwzwSdy9uiNA043iiBGCm6aMvF4Kl4kHbURcxTh7OkkeTqzAJXAyPFpNV9weQ74hbDQlmO002r41WkhF',
  test_stripe_priceId: 'price_1I8SbQCSTmdgoUr3yzDqxQGp',
  test_stripe_priceId_1200: 'price_1J1FeSCSTmdgoUr3YvbY8oGj',
  test_stripe_priceId_1500: 'price_1J7tOaCSTmdgoUr32scrdwH3',
  test_stripe_priceId_3000: 'price_1J1FijCSTmdgoUr3p1oi9MsX',
  test_stripe_priceId_4000: 'price_1J560BCSTmdgoUr3WjFEwq1t',
  test_stripe_priceId_10000: 'price_1J566eCSTmdgoUr3jbIrXYIV',
  zoom_api_key:'7eP9s5v4QHWT9ZeLCsnG3Q',
  dev_domain_name:'https://dev1.iylon.com',
  prod_domain_name:'https://app.iylon.com',
  api_url: 'https://app.iylon.com/api'
  // api_url: 'https://app.iylon.com/api',

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
